<div class="background" [class.shown]="isLoading">
  <div class="logo">
    <svg-icon key="loading-full-screen" fontSize="150px"></svg-icon>
  </div>
</div>
